import {
  multi,
  number,
  OTHER,
  option,
  single,
  type UsWorksheetDefinition,
} from "../us-fields";

export const US_APPENDIX: UsWorksheetDefinition = {
  examType: "us_appendix",
  version: 1,
  indications: [
    option("rlq_pain", "RLQ pain"),
    option("fever", "Fever"),
    option("vomiting", "Vomiting"),
  ],
  otherIndication: true,
  sections: [
    {
      id: "appendix_findings",
      label: "Findings",
      role: "findings",
      technicallyLimited: true,
      fields: [
        single(
          "appendix.visualized",
          "Appendix visualized",
          [option("no", "No"), option("yes", "Yes")],
          { normal: "yes" },
        ),
        number("appendix.size", "Appendix size", "mm"),
        single(
          "appendix.compressibility",
          "Appendix compressibility",
          [
            option("compressible", "Appendix compressible"),
            option("not_compressible", "Appendix not compressible"),
          ],
          { normal: "compressible" },
        ),
        single(
          "appendix.appendicolith",
          "Appendicolith",
          [option("absent", "absent"), option("present", "present")],
          { normal: "absent" },
        ),
        single(
          "appendix.color_flow",
          "Peri-appendiceal color flow",
          [
            option("minimal", "Minimal or none"),
            option("increased", "increased"),
            OTHER,
          ],
          { normal: "minimal" },
        ),
      ],
    },
    {
      id: "appendix_impression",
      label: "Impression",
      role: "impression",
      fields: [
        multi("appendix.impression", "Impression", [
          option("normal_appendix", "Normal appendix"),
          option("appendicitis", "Appendicitis"),
          OTHER,
          option("indeterminate", "Indeterminate"),
        ]),
      ],
    },
  ],
  normalImpressions: [
    { sectionId: "appendix_impression", value: "normal_appendix" },
  ],
  billing: {
    codes: [
      { cpt: "76705", label: "Abdominal ultrasound, limited", preTick: true },
    ],
  },
};
